import { backHandler, headerCount, headerTitle, refreshHandler } from '../reducers/reducer'
import store from '../stores/app-store'

const setHeaderTitle = (title?: string) => {
    store.dispatch(headerTitle(title))
}

const setHeaderCount = (count?: string) => {
    store.dispatch(headerCount(count))
}

const setRefreshHandler = (RefreshHandler?: () => void) => {
    store.dispatch(refreshHandler(RefreshHandler))
}

const setBackHandler = (BackHandler?: () => void) => {
    store.dispatch(backHandler(BackHandler))
}

export { setBackHandler, setHeaderCount, setHeaderTitle, setRefreshHandler }

